import { StyleSheet } from 'react-native';

export const commonStyles = StyleSheet.create({
    scrollView: {
        paddingTop: 8,
        paddingBottom: 12,
    },
});
